import numberTruncate from './number-truncate.format';

export default function percentageTruncate() {
  return function truncate(target: number | string) {
    return numberTruncate()(Number(target) * 100) + '%';
  };
}
